import { useQuery } from '@tanstack/react-query';
import {
  fetchDashboardData,
  fetchDashboardKpis,
  fetchThroughput,
  fetchCategoryBreakdown,
  type DashboardData,
  type DashboardKpis,
  type ThroughputPoint,
  type CategoryBreakdown,
} from '@/services/dashboardService';

/** Fetch all dashboard data in a single query */
export function useDashboard() {
  return useQuery<DashboardData>({
    queryKey: ['dashboard'],
    queryFn: fetchDashboardData,
    staleTime: 30_000, // 30s — dashboard refreshes on revisit
    refetchInterval: 60_000, // auto-refresh every 60s
  });
}

/** Granular: KPIs only */
export function useDashboardKpis() {
  return useQuery<DashboardKpis>({
    queryKey: ['dashboard', 'kpis'],
    queryFn: fetchDashboardKpis,
    staleTime: 30_000,
  });
}

/** Granular: Throughput chart */
export function useThroughput() {
  return useQuery<ThroughputPoint[]>({
    queryKey: ['dashboard', 'throughput'],
    queryFn: fetchThroughput,
    staleTime: 60_000,
  });
}

/** Granular: Category pie chart */
export function useCategoryBreakdown() {
  return useQuery<CategoryBreakdown[]>({
    queryKey: ['dashboard', 'categories'],
    queryFn: fetchCategoryBreakdown,
    staleTime: 60_000,
  });
}
